import 'es5-shim';
import 'es6-shim';
import './index.less';
import 'antd-mobile/dist/antd-mobile.css';
import DY, {ServiceHelper} from 'dy';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from "../../AppStore/SmartMoney/index/App";
import YdyScrollView from "@/components/YdyScrollView";
// import registerServiceWorker from '@/registerServiceWorker';
window['DY'] = DY;
ServiceHelper.HttpService.getConfig().then(() => {
  ReactDOM.render((<YdyScrollView><App /></YdyScrollView>), document.getElementById('root'));
})
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/app/SmartMoney/index.tsx